import config from '@/config'

export default {
	id: 'SIMPLE_PAYWALL_3M_59_99_3M_29_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_3m_59_99_3m_29_99_usd',
			EUR: 'simple_premium_3m_59_99_3m_29_99_eur',
			GBP: 'simple_premium_3m_59_99_3m_29_99_gbp',
			AUD: 'simple_premium_3m_99_99_3m_43_99_aud',
			CAD: 'simple_premium_3m_99_99_3m_43_99_cad',
			DKK: 'simple_premium_3m_459_3m_229_dkk',
			SEK: 'simple_premium_3m_699_3m_349_sek',
			NOK: 'simple_premium_3m_699_3m_349_nok',
			BRL: 'simple_premium_3m_179_3m_69_brl',
			MXN: 'simple_premium_3m_999_3m_499_mxn',
			TRY: 'simple_premium_3m_1999_3m_999_try',
			ARS: 'simple_premium_3m_79990_3m_39990_ars',
			COP: 'simple_premium_3m_239990_3m_119990_cop',
			CLP: 'simple_premium_3m_57990_3m_29990_clp',
		},
		primer: 'prd_h9Nz9vfE4hKz',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 43.99,
			CAD: 43.99,
			DKK: 229,
			SEK: 349,
			NOK: 349,
			BRL: 69,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
		originalPriceMap: {
			USD: 59.99,
			EUR: 59.99,
			GBP: 59.99,
			AUD: 99.99,
			CAD: 99.99,
			DKK: 459,
			SEK: 699,
			NOK: 699,
			BRL: 179,
			MXN: 999,
			TRY: 1999,
			ARS: 79990,
			COP: 239990,
			CLP: 57990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 59.99,
			EUR: 59.99,
			GBP: 59.99,
			AUD: 99.99,
			CAD: 99.99,
			DKK: 459,
			SEK: 699,
			NOK: 699,
			BRL: 179,
			MXN: 999,
			TRY: 1999,
			ARS: 79990,
			COP: 239990,
			CLP: 57990,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.90_days.into_period_text'), // 'first quarter'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.90_days.sub_period_text'), // 'quarterly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.90_days.into_period_text'), // 'three months'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.90_days.period_text'), // '3-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.90_days.sub_period_text'), // '3-month'
	}),
}
